import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { colors } from './colors';

const theme = extendTheme({
  colors,
});

export const ThemeWrapper = ({ children }: { children: React.ReactNode }) => {
  return <ChakraProvider theme={theme}>{children}</ChakraProvider>;
};
